import { Box, BoxProps, Button, Tooltip } from "@mui/material";
import React from "react";
import { useAddToCart } from "../common/addToCart";
import { getProductKind, ProductKind } from "../common/productKind";

export type AddToCartControlProps = BoxProps & {
  productId: string;
  isVoucher?: boolean;
  isCertificate?: boolean;
  productKind?: ProductKind;
  disabled?: boolean;
  disabledTitle?: string;
  buttonText?: string;
};

export const AddToCartControl = (props: AddToCartControlProps) => {
  const {
    productId,
    isVoucher,
    isCertificate,
    productKind,
    disabled,
    disabledTitle,
    buttonText,
    ...boxProps
  } = props;

  const kind =
    productKind ?? getProductKind({ isVoucher, isCertificate });

  const [addToCart, canAddToCart] = useAddToCart();
  const allowed = !disabled && canAddToCart(kind);
  const onClick = React.useCallback(
    async (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      if (allowed) {
        await addToCart(productId);
      }
    },
    [productId, allowed, addToCart],
  );
  return (
    <Box {...boxProps}>
      <Tooltip
        title={
          allowed
            ? "В корзину"
            : (disabledTitle ??
              "Нельзя добавить больше одного вида товаров")
        }
      >
        <span>
          <Button
            variant="contained"
            color="secondary"
            onClick={onClick}
            disabled={!allowed}
          >
            {buttonText ?? "В корзину"}
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
};
